// extracted by mini-css-extract-plugin
module.exports = {"option":"subscription-option_option__2Ce5s","check-icon-wrap":"subscription-option_check-icon-wrap__sb4f_"};